




































































































































import { CustomMarker, ClusterMarker } from '~/models/search/map/types'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { Classified } from '~/models/classified/types'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { USER_NS } from '~/store/modules/shared/user/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { facetChanged } from '~/store/modules/shared/classifieds/search/action-types'
import SearchMixin from '~/components/car/classifieds/search/SearchMixin.vue'
import { setUrlParam } from '~/utils/http'
import {
  SET_PARAM,
  SET_MAP_SEARCH_FLAG,
  CLEAR_MAP_DATA
} from '~/store/modules/shared/classifieds/search/mutation-types'
import { STORAGE_NS } from '~/store/modules/shared/storage/state'
import { ViewType } from '~/models/shared/types'
import { Facet as FacetType } from '~/models/search/types'
import { toCamelCase } from '~/utils/object'
import { bounceToString } from '~/components/shared/configurable/map/leaflet'
import { mapDeps } from '~/plugins/dependency-container/utils'
import CompareService from '~/services/compare/CompareService'
import ClassifiedMapSearchResults from '~/components/car/classifieds/map-search/results/ClassifiedMapSearchResults.vue'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import Facet from '~/components/car/classifieds/search/facets/Facet.vue'
import ClassifiedMapSearchFacets from '~/components/car/classifieds/map-search/facets/ClassifiedMapSearchFacets.vue'
import ClassifiedMapSearchMap from '~/components/car/classifieds/map-search/ClassifiedMapSearchMap.vue'
import ClassifiedMapSearchMobileSearch from '~/components/car/classifieds/map-search/ClassifiedMapSearchMobileSearch.vue'
import ClassifiedMapSearchClassifiedView from '~/components/car/classifieds/map-search/ClassifiedMapSearchClassifiedView.vue'
import CClassifiedCompareCounter from '~/components/shared/configurable/classified/compare/CClassifiedCompareCounter.vue'

const RESULTS_WIDTH = 764

export default defineComponent({
  components: {
    Facet,
    ClassifiedMapSearchFacets,
    ClassifiedMapSearchResults,
    ClassifiedMapSearchMap,
    ClassifiedMapSearchMobileSearch,
    ClassifiedMapSearchClassifiedView,
    CClassifiedCompareCounter,
    ClassifiedMapSearchResultsClusterModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/map-search/results/ClassifiedMapSearchResultsClusterModal.vue'
      )
    )
  },
  mixins: [SearchMixin],
  data() {
    return {
      hoveredClassified: null,
      isModalFacetsVisible: false,
      isComponentMouted: false,
      resultsWidth: RESULTS_WIDTH,
      minResultsWidth: RESULTS_WIDTH,
      isDragStart: false,
      resultsStartWidth: null,
      startX: null,
      columns: 2,
      resizeIcon: faChevronLeft,
      isLeftArrowVisible: false,
      isRightArrowVisible: true,
      isFullClassifiedVisible: !!this.$router.currentRoute.params.slugOrId,
      slugOrId: this.$router.currentRoute.params.slugOrId,
      isClusterResultsModalVisible: false,
      clusterGeolocation: '',
      frozenGeolocation: null,
      isListFrozen: false,
      csp: null,
      queryParamsOnClassifiedClick: null,
      isResultsHeaderVisible: true
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      rows: state => state.rows,
      loadingResults: state => state.loading.results,
      currentPage: state => state.pagination.page,
      params: state => state.params,
      query: state => state.currentRoute.query,
      loadingFacets: state => state.loading.facets,
      loadingClusterResults: state => state.loading.clusterResults,
      viewType: state => state.viewType,
      facets: state => state.facets,
      sellerRows: state => state.sellerRows,
      mapSearchUrl: state => state.mapSearchUrl
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => toCamelCase(state.classified),
      error: state => toCamelCase(state.error)
    }),
    ...mapGetters(STORAGE_NS, {
      getItem: 'getItem'
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      currentCategoryId: 'getCurrentCategoryId',
      showSellers: 'showSellers',
      inPlotSearch: 'inPlotSearch'
    }),
    ...mapDeps({ compareService: CompareService }),
    isMapClassifiedViewVisible() {
      return this.slugOrId && this.isFullClassifiedVisible && !this.isMobile
    },
    isClassifiedDeletedOrRemoved() {
      return this.error?.status === 410
    },
    isCompareCountVisible(): boolean {
      const compare = this.getItem('compare')
      if (!compare || !this.currentCategoryId) {
        return false
      }

      return !!(compare[this.currentCategoryId]?.length || null)
    },
    dragTitle() {
      return this.viewType === ViewType.LIST && !this.isMapClassifiedViewVisible
        ? this.$i18n.t(
            'choose the {viewtype} option in order to see up to 4 columns of classifieds',
            { viewtype: 'Gallery' }
          )
        : this.$i18n.t('drag')
    },
    locationParam() {
      return this.params.location2
    },
    richGeolocation() {
      return this.params['rich-geolocation']
    },
    adminMeinFacet() {
      return this.facets.find(f => f.name === 'admin_mein')
    },
    rowsPerView(): [] {
      if (this.showSellers) {
        return this.sellerRows || []
      }

      return this.rows || []
    },
    isCompareCounterVisible() {
      return (
        (!this.isMapClassifiedViewVisible &&
          !this.showSellers &&
          !this.isResultsHeaderVisible) ||
        (!this.isResultsHeaderVisible && this.hasShopParam)
      )
    },
    hasShopParam() {
      return this.params.shop?.length
    }
  },
  watch: {
    '$route.params'(params) {
      this.slugOrId = params.slugOrId
      if (params.slugOrId) {
        this.isFullClassifiedVisible = true
      } else {
        this.isFullClassifiedVisible = false
      }
    },
    currentPage() {
      this.scrollResultsToTop()
    },
    locationParam(newValue) {
      if (newValue && !this.isMobile) {
        this.handleLocationChange()
      }
    },
    richGeolocation(newValue) {
      if (newValue?.length && !this.isMobile) {
        this.handleLocationChange()
      }
    },
    'params.postcode'(newVal: [], oldVal: []) {
      if (
        newVal?.length &&
        newVal?.toString() !== oldVal?.toString() &&
        !this.isMobile
      ) {
        this.handleLocationChange()
      }
    },
    facets() {
      this.isListFrozen = false
    }
  },
  mounted() {
    this.isComponentMouted = true
    if (
      this.params['show-clusters'] &&
      this.params['show-clusters'].length &&
      this.params?.cgeolocation?.length
    ) {
      this.isClusterResultsModalVisible = true
    }
  },
  beforeDestroy() {
    this.setMapSearchFlag(false)
    this.clearMapData()
  },

  methods: {
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      toggleMobileFacets: 'toggleMobileFacets',
      facetChanged,
      searchForResults: 'searchForResults',
      searchForSellers: 'searchForSellers',
      updateUrl: 'updateUrl',
      updateRoutes: 'updateRoutes',
      changePage: 'changePage'
    }),
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setParam: SET_PARAM,
      setMapSearchFlag: SET_MAP_SEARCH_FLAG,
      clearMapData: CLEAR_MAP_DATA
    }),

    ...mapActions(CLASSIFIED_VIEW_NS, {
      navigateToClassifiedView: 'navigateToClassifiedView'
    }),
    onClassifiedHover(classified: Classified | null) {
      this.hoveredClassified = classified
    },
    onDragStart(e: MouseEvent) {
      this.isDragStart = true
      this.startX = e.clientX
      this.resultsStartWidth = this.resultsWidth
    },
    onDragStop() {
      this.isDragStart = false
    },
    onDrag(e: MouseEvent) {
      if (this.isDragStart && this.isComponentMouted) {
        e.preventDefault()
        const width = this.resultsStartWidth + e.clientX - this.startX
        const { clientWidth } = this.$refs.rowContainer?.$el.offsetParent
        const maxWidth = clientWidth - width
        if (maxWidth > 350 && width > this.minResultsWidth) {
          this.resultsWidth = width
        }
        this.displayResizeArrowsDirections(maxWidth)
        this.calcColumns(this.resultsWidth)
        if (this.$refs.mapClassifiedView) {
          this.$refs.mapClassifiedView.invalidateMapSize()
        }
      }
    },
    calcColumns(pixels: number) {
      if (pixels <= this.minResultsWidth + 37 && pixels > 400) {
        this.columns = 2
      } else if (
        pixels > this.minResultsWidth + 37 &&
        pixels <= this.minResultsWidth + 300
      ) {
        this.columns = 3
      } else {
        this.columns = 4
      }
    },
    displayResizeArrowsDirections(maxWidth: number) {
      if (this.resultsWidth < this.minResultsWidth + 5) {
        this.isLeftArrowVisible = false
        this.isRightArrowVisible = true
      } else if (this.resultsWidth > this.minResultsWidth && maxWidth > 350) {
        this.isLeftArrowVisible = true
        this.isRightArrowVisible = true
      } else if (maxWidth < 353) {
        this.isRightArrowVisible = false
        this.isLeftArrowVisible = true
      }
    },
    async onClassifiedClick(payload) {
      const { classified, e, thumbData } = payload
      const query = this.query
      if (this.$refs.results?.$refs?.resultsContainer) {
        this.csp = this.$refs.results.$refs.resultsContainer.scrollTop
      }
      this.queryParamsOnClassifiedClick = query

      const { urlSlug } = classified
      this.hoveredClassified = null
      this.isFullClassifiedVisible = true
      this.slugOrId = `${classified.id}${urlSlug ? '-' + urlSlug : ''}`
      const navigateBaseUrl = this.inPlotSearch
        ? '/plot/map/'
        : this.mapSearchUrl?.split('?')[0]

      const refs = {
        categoryIds: thumbData.categoryIds || classified.categoryIds,
        id: thumbData.id || classified.id,
        isParked: thumbData.isParked || classified.isParked,
        thumb: thumbData.thumb || classified.thumb,
        title: thumbData.title || classified.title,
        price: thumbData.price || classified.price,
        salary: thumbData.salary || classified.salary,
        payment: thumbData.payment || classified.payment,
        thumbIndex: thumbData.thumbIndex || 0,
        offertype: thumbData.offertype || classified.offertype,
        hasPhotos: thumbData.hasPhotos || classified.hasPhotos,
        thumbsLength:
          thumbData.thumbsLength ||
          (classified.thumbs ? classified.thumbs.count : 0),
        externalLink: thumbData.externalLink || classified.externalLink,
        discount: classified.discount,
        goToMessagesOnLoad: false
      }

      if (refs.hasPhotos && classified.has_360photos) {
        // first index is always the 360 photo preview, so:
        refs.thumbIndex++
      }

      if (e && e.goToMessages) {
        refs.goToMessagesOnLoad = e.goToMessages
      }

      await this.navigateToClassifiedView({
        evt: e,
        url: navigateBaseUrl + this.slugOrId,
        setSp: true,
        refs,
        element: this.$refs.results?.$refs?.resultsContainer
          ? this.$refs.results.$refs.resultsContainer
          : null,
        query,
        navigateInSearch: true,
        spParamName: 'csp'
      })
      this.setParam({ name: 'slugOrId', value: this.slugOrId })
    },
    async onCloseClassifiedView() {
      this.slugOrId = null
      this.isFullClassifiedVisible = false
      let newPageUrl = this.mapSearchUrl
      if (this.inPlotSearch) {
        newPageUrl = this.$router.resolve({
          name: '__classifieds_search_plot_map',
          query: {
            ...this.$router.currentRoute.query,
            csp: undefined
          }
        }).href
      }
      await this.updateUrl(newPageUrl)
      this.$router.push({
        path: newPageUrl
      })
    },
    onMarkerClick({ marker }: { marker: CustomMarker }) {
      const classified: Classified = { id: marker.id }
      this.onClassifiedClick({ classified, thumbData: {} })
    },
    clealAllFacets() {
      const paramsArray = []
      this.facets.forEach(f => {
        if (f.isSelected && f.values?.params?.length) {
          const { params } = f.values
          paramsArray.push(params.map(p => p[0]))
        }
      })
      const params = paramsArray.flat().map(u => ({ name: u, value: null }))
      const facetParams = {
        params,
        geolocation: null
      }
      const bounds = this.$refs.map.getBounds()
      if (bounds) {
        const { northEast, southWest } = bounds
        facetParams.geolocation = bounceToString(northEast, southWest)
      }
      if (paramsArray.length) {
        this.facetChanged(facetParams)
      }
    },
    handleClusterWithMultipleClassifieds(cluster: ClusterMarker) {
      this.clusterGeolocation = cluster.rect
        .map(c => Object.values(c).join('x'))
        .join(',')

      this.isClusterResultsModalVisible = true
    },
    handleClosestLocation() {
      this.$refs.map.setLocationStatus()
    },
    async handlePageChange(pg: number) {
      this.csp = null
      if (pg !== this.currentPage) {
        const newPageUrl = setUrlParam(
          `${window.location.pathname}${window.location.search}`,
          'pg',
          pg
        )
        await this.updateUrl(newPageUrl)
        this.updateRoutes()
        await this.changePage({ page: pg })
        if (this.isListFrozen && this.frozenGeolocation) {
          this.setParam({
            name: 'geolocation',
            value: this.frozenGeolocation
          })
        } else if (this.query.geolocation) {
          this.setParam({
            name: 'geolocation',
            value: this.query.geolocation
          })
        }
        if (this.showSellers) {
          await this.searchForSellers({ loading: true, pageView: true })
        } else {
          await this.searchForResults({ loading: true, pageView: true })
        }
        this.scrollResultsToTop()
      }
    },
    handleBoundsMoved() {
      this.scrollResultsToTop()
      this.csp = null
    },
    scrollResultsToTop() {
      if (this.$refs?.results && !this.isListFrozen) {
        this.$refs.results.scrollToTop()
      }
    },
    handleFreezeList(isFrozen: boolean) {
      this.isListFrozen = isFrozen
      if (isFrozen) {
        this.frozenGeolocation = this.query.geolocation
      } else {
        this.$nextTick(() =>
          this.$refs.map.fetchMarkersAndResultsOnUnfreezeList()
        )
        this.frozenGeolocation = null
      }
      this.scrollResultsToTop()
    },
    handleRemovePairs(facet: FacetType) {
      if (facet.name === 'location') {
        this.handleLocationChange()
      }
    },
    handleLocationChange() {
      this.isListFrozen = false
      this.$refs.map.setLocationStatus()
    },
    handleShowExactLocation(showExactLocation: boolean) {
      this.facetChanged({
        params: [{ name: 'exact_location', value: +showExactLocation }]
      })
    },
    handleCloseAgentProfile(geolocation: string = null) {
      this.setParam({ name: 'shop', value: null })
      this.setParam({ name: 'show-sellers', value: true })
      this.setParam({
        name: 'geolocation',
        value: geolocation || this.$refs.map.grGeolocation
      })
      this.search()
    },
    handleSelectedSeller() {
      this.isListFrozen = false
      this.$refs.map.zoomToSeller()
    }
  }
})
